import { PayloadAction } from "@reduxjs/toolkit";
import { Page } from "../../../../utl/models/Page";
import { EmployeesState } from "../models/EmployeesState";

const setPageEmployees = (state: EmployeesState, action: PayloadAction<Page>) => {
    state.page = action.payload.page;
}

export default setPageEmployees;